const StoreSEO = `
    general_info.store_meta,            store_meta,             true;
    general_info.meta_keywords,         store_meta_keywords;
    general_info.meta_desc,             store_meta_desc,        true;
    general_info.url_key,               url_key;
`

export default StoreSEO;